import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import { Switch } from "../ui/switch";

export default function EditLeadCapture({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setField = (i, key, v) => {
    const fields = [...(value.fields || [])];
    fields[i] = { ...fields[i], [key]: v };
    set("fields", fields);
  };
  const add = () => set("fields", [...(value.fields || []), { key: "custom", label: "Novo campo", required: false }]);
  const remove = (i) => set("fields", (value.fields || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Formulário de Captura de Leads">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="lead-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="lead-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="lead-subtitle-input" /></Field>
        <Field label="Texto do botão"><TextInput value={value.submitLabel} onChange={(v) => set("submitLabel", v)} testId="lead-submit-input" /></Field>
        <Field label="Mensagem de sucesso"><TextInput value={value.successMessage} onChange={(v) => set("successMessage", v)} testId="lead-success-input" /></Field>
        <Field label="Nota de privacidade (texto pequeno)"><TextInput value={value.privacyNote} onChange={(v) => set("privacyNote", v)} testId="lead-privacy-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Campos do formulário</span>
            <ListAddBtn onClick={add} label="Adicionar campo" testId="lead-field-add" />
          </div>
          <div className="space-y-3">
            {(value.fields || []).map((f, i) => (
              <div key={i} data-testid={`lead-field-row-${i}`} className="grid sm:grid-cols-12 gap-3 items-center border border-border p-3">
                <div className="sm:col-span-3">
                  <Field label="Chave">
                    <select
                      data-testid={`lead-field-key-${i}`}
                      value={f.key}
                      onChange={(e) => setField(i, "key", e.target.value)}
                      className="w-full px-3 py-2.5 border border-border bg-white text-onyx text-sm focus:outline-none focus:border-gold"
                    >
                      <option value="name">name</option>
                      <option value="phone">phone</option>
                      <option value="email">email</option>
                    </select>
                  </Field>
                </div>
                <div className="sm:col-span-6"><Field label="Rótulo"><TextInput value={f.label} onChange={(v) => setField(i, "label", v)} testId={`lead-field-label-${i}`} /></Field></div>
                <div className="sm:col-span-2 flex items-center gap-2 pt-6">
                  <Switch
                    data-testid={`lead-field-required-${i}`}
                    checked={!!f.required}
                    onCheckedChange={(c) => setField(i, "required", c)}
                  />
                  <span className="text-xs">Obrig.</span>
                </div>
                <div className="sm:col-span-1 flex justify-end pt-6"><ListRemoveBtn onClick={() => remove(i)} testId={`lead-field-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
